// import { TitleBar } from '@/services/Forms/Forms'
import { Checkbox_, Input_, Kotak, Select_, TitleBar } from '@/services/Forms/FormsSatu'
import { EditFilled, UploadOutlined } from '@ant-design/icons'
import { Checkbox, Form, Input, Select, Tabs } from 'antd'
import MainLayouts from 'layouts/MainLayouts'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Date_ } from 'services/Forms/Forms'
import { Button_, Number_, Switch_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'
import ChecklistPolaMakan from './ChecklistPolaMakan'
import FormHidanganSehari from 'pages/FormHidanganSehari/FormHidanganSehari'
import { HAPUS_IFUNDEFINE } from 'services'
import _Api from 'services/Api/_Api'
import moment from 'moment'
import dayjs from 'dayjs'

function IdentitasPasien(pr) {

    const [frm] = Form.useForm()

    const [data, setdata] = useState([])
    const [agama, setagama] = useState()
    const [jeniskelamin, setjeniskelamin] = useState()
    const [pendidikan, setpendidikan] = useState()
    const [listDiet, setlistDiet] = useState([])

    const FORM_ID = 2
    const KONSELING_ID = pr.konseling_id

    const getCombo = () => {
        _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
            // setcombo(res)
            var dt = res.data.combo
            var rc = res.data.record
            var konseling = res.data.konseling?.pembeli

            // {
            //     "id": 26,
            //     "aktif": 1,
            //     "namapembeli": "Faizar Hafidz",
            //     "alamatlengkap": "Mataram",
            //     "id_kotakabupaten": 22,
            //     "nohp": "087",
            //     "email": "pspdfkunizar2023@gmail.com",
            //     "deviceid": null,
            //     "jeniskelamin": null,
            //     "tgllahir": null,
            //     "devicemodel": null,
            //     "updated_at": "2025-03-10T03:03:00.000000Z",
            //     "created_at": "2023-01-09T11:09:45.000000Z"
            // }

            setdata(rc)
            setlistDiet(res.data.listdiet)

            var konseling = {
                "nama": konseling?.namapembeli,
                "pembeli_id": konseling?.id.toString(),
                "alamat": konseling?.alamatlengkap,
                "nohp": konseling?.nohp,
            }
            

            frm.setFieldsValue(konseling)



            var initfield = {}

            rc.map(gg => {
                if (gg.tipedata == "checkbox") {
                    initfield.centang = { ...initfield.centang, [gg.fiel_fk]: gg.value == 1 }
                } else
                    if (gg.tipedata == "textbox") {
                        initfield[gg.fiel_fk] = gg.value
                    } else
                        if (gg.tipedata == "int") {
                            initfield[gg.fiel_fk] = parseInt(gg.value)
                        } else
                            if (gg.tipedata == "date") {
                                initfield[gg.fiel_fk] = moment(gg.value)
                            } else
                                if (gg.tipedata == "multiple" && gg.value != undefined) {
                                    var vlll = gg.value.split(",")
                                    initfield[gg.fiel_fk] = vlll
                                }
            })
            frm.setFieldsValue(initfield)
            console.log(initfield)

            const agama = dt.filter(x => x.kelompok_id == "2")
            setagama(agama)

            const jk = dt.filter(x => x.kelompok_id == "1")
            setjeniskelamin(jk)

            const pdd = dt.filter(x => x.kelompok_id == "3")
            setpendidikan(pdd)
        })
    }
    const simpanData = () => {
        // console.log(val)
        // debugger
        frm.validateFields().then(val => {
            var pure = HAPUS_IFUNDEFINE(val)
            // delete cek.centang
            const cheklist = HAPUS_IFUNDEFINE(val.centang)
            var obj = {
                konseling_id: KONSELING_ID,
                form_id: FORM_ID,
                // diet : ,
                data: { 
                    ...pure, 
                    ...cheklist, 
                    diet: pure.diet && pure.diet.length > 0 ? pure.diet.toString() : "",
                    diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
                }
            }
            delete obj.data.centang
            _Api.post("simpan-form-konseling", obj).then(rs => {
                msg.auto(rs.data)
                if(rs.data.sts == 1){
                    window.location.reload()
                }
                 
            })
        }).catch(err => {
            console.log(err)
            msg.error("Silahkan lengkapi data ")
        })
    }

    const hitungIMT = () => { 
        var bb = frm.getFieldValue("bb") ?? 0
        var tb = frm.getFieldValue("tb") ?? 0
        var imt = (bb / (tb * tb) * 10000).toFixed(2)
        frm.setFieldsValue({ "imt": imt })
    }

    useEffect(() => {
        getCombo()
        // frm.setFieldsValue({ "centang": { "jagung_1": true, } })
    }, [])
 

    const hitungUmur = () => {
        var tgl = frm.getFieldValue("tgllahir")
        var umur = dayjs().diff(tgl, 'year').toString()
        frm.setFieldsValue({ "umur": umur })
    }
   
    return (
        <div className='border p-3 border-dark'>
            <div className='mb-2 '>
                <TitleBar label="Identitas Pasien" />
            </div>
            <Form layout='vertical' form={frm}

                // initialValues={{
                //     centangya: true, // Single checkbox initial value
                //   }}
                onFinish={simpanData}>
                <fieldset >
                    <Row className='p-1'>
                        <Input_ label="No. RM" sm="2" name="rm" />
                        <Input_ label="Nama" required sm="5" name="nama" />
                        <Select_ label="Jenis Kelamin" required sm="2" name="jeniskelamin_id" option={jeniskelamin} val="caption1" caption="caption" />
                        <Date_ label="Tanggal Lahir" onChange={hitungUmur} format="DD-MM-YYYY" required sm="3" name="tgllahir" />
                        <Input_ label="Umur" required sm="2" readOnly name="umur" addonAfter="Thn" />
                        <Number_  onChange={hitungIMT} required label="Tinggi Badan (TB)" sm="2" name="tb" addonAfter="cm" />
                        <Number_ onChange={hitungIMT} label="Berat Badan (BB)" required sm="2" name="bb" addonAfter="Kg" />
                        <Input_ disabled label="IMT" sm="2" name="imt" required />
                        {/* <Select_ label="Agama" sm="2" name="agama_id" option={agama} val="id" caption="caption" /> */}
                        <Select_ label="Pendidikan" sm="3" name="pendidikan_id" option={pendidikan} val="id" caption="caption" />
                        {/* <Input_ label="Aktivitas" sm="3" name="aktivitas" /> */}
                        <Input_ label="Alamat 11" required sm="12" multiline name="alamat" />
                        <Input_ hidden  name="pembeli_id" />
                 
                    </Row>
                </fieldset>
                <Button_ sm="2" icon={<EditFilled />} block title="Ubah Identitas" onClick={simpanData} />

            </Form>
         
        </div>
    )
}
export default IdentitasPasien;

